import { useState, useEffect } from "react";

const useCooldownTimer = (initialValue = 0) => {
  const [cooldown, setCooldown] = useState(initialValue);

  useEffect(() => {
    if (cooldown <= 0) return;

    const timer = setInterval(() => {
      setCooldown(prev => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [cooldown]);

  return [cooldown, setCooldown];
};

export default useCooldownTimer;
